import styles from '@sicredi/styles/_simulation-box.scss';
import cn from 'clsx';
import * as React from 'react';
import Item, { Props as ItemProps } from './Item';

export interface Props extends React.HTMLAttributes<HTMLElement> {
  children?: React.ReactNode;
  noContentMessage?: string;
}

export interface CompoundedSimulationBox extends React.FC<Props> {
  Item: React.FC<ItemProps>;
}

const SimulationBox: CompoundedSimulationBox = ({
  noContentMessage,
  children,
  className,
  ...props
}) => {
  const content = React.Children.toArray(children);

  return (
    <div
      className={
        cn(
          styles['sicredi-simulation-box'],
          className
        )
      }
      {...props}>

      {!content.length && !!noContentMessage && <p className={cn(styles['no-content-message'])}>{noContentMessage}</p>}

      {!!content.length &&
        <ul className={styles['items']}>
          {content}
        </ul>
      }
    </div>
  );
};

SimulationBox.Item = Item;

export default SimulationBox;
